import Alpine from "alpinejs";
import Swiper, {Pagination, Navigation} from "swiper";

Alpine.data("swiper", (maxSlides) => ({
    options: {
        modules: [Pagination, Navigation],
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            clickable: true,
            el: ".swiper-pagination",
            type: "bullets",
            renderBullet: (index, className) =>
                `<div class="${className}"><div class="swiper-pagination-bullet_inner"></div></div>`,
        },
        slidesPerView: "auto",
        spaceBetween: 18,
        breakpoints: {
            475: {
                slidesPerView: 1,
            },
            640: {
                slidesPerView: Math.max(1.1, (640 / 1184) * maxSlides),
                spaceBetween: 24,
            },
            768: {
                slidesPerView: Math.max(1.1, (768 / 1184) * maxSlides),
            },
            860: {
                slidesPerView: Math.max(1.1, (860 / 1184) * maxSlides),
            },
            1024: {
                slidesPerView: Math.max(1.1, (1024 / 1184) * maxSlides),
            },
            1184: {
                slidesPerView: maxSlides,
                spaceBetween: 32,
            },
        },
    },
    init() {
        this.$nextTick(() => {
            new Swiper(this.$el, this.options);
        });
    },
}));
